import { ResponsiveImageUrls } from '@/types';

export interface PopupsBlockProps {
  popups: PopupCardProps[];
}

export type PopupCardProps = (
  MembersPopupProps |
  TextsPopupProps |
  ImagePopupProps |
  SimpleBulletPopupProps |
  BulletDescriptionPopupProps
);

export enum CareerPopupType {
  MembersPopup,
  TextsPopup,
  ImagePopup,
  SimpleBulletPopup,
  BulletDescriptionPopup,
}

export enum CareersColors {
  Red = 'red',
  Green = 'green',
  Blue = 'blue',
  Yellow = 'yellow',
  Black = 'black',
  Emerald = 'emerald',
}

interface BaseCareerPopupProps {
  title: string;
  description: string;
  hoverColor: CareersColors;
  backgroundImage: ResponsiveImageUrls | null;
  popupType: CareerPopupType;
  popupKey?: string;
}

export interface MembersPopupProps extends BaseCareerPopupProps {
  members: MemberCareer[];
}

export interface MemberCareer {
  photoUrl: string | null;
  photoColor: CareersColors;
  fullName: string;
  profession: string;
  linkedInUrl: string | null;
}

export interface TextsPopupProps extends BaseCareerPopupProps {
  textBlocks: SimpleBlock[];
}

export interface SimpleBlock {
  title: string | null;
  description: string;
}

export interface ImagePopupProps extends BaseCareerPopupProps {
  leftImage: string | null;
  rightImages: string[] | null;
}

export interface SimpleBulletPopupProps extends BaseCareerPopupProps {
  bullets: IconBullet[];
}

export interface IconBullet {
  text: string;
  iconUrl: string | null;
}

export interface BulletDescriptionPopupProps extends BaseCareerPopupProps {
  bullets: IconDescriptionBullet[];
  defaultBulletUrl: string | null;
}

export interface IconDescriptionBullet extends IconBullet {
  description: string;
}
